(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-expert-opinion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initExpertOpinion() {
    document.querySelectorAll('[data-sd-expert-opinion]').forEach(function (root) {
      if (root.dataset.sdExpertInit) return;
      root.dataset.sdExpertInit = '1';

      var track = root.querySelector('[data-sd-expert-track]');
      var slides = Array.from(root.querySelectorAll('[data-sd-expert-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-sd-expert-dot]'));
      var prev = root.querySelector('[data-sd-expert-prev]');
      var next = root.querySelector('[data-sd-expert-next]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!track || slides.length < 2) return;

      function activeIndex() {
        var width = track.getBoundingClientRect().width || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      }

      function setActiveDot() {
        var index = activeIndex();
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function goTo(index) {
        var slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });

      var frame = 0;
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(setActiveDot);
      }, { passive: true });
      setActiveDot();
    });
  }

  initExpertOpinion();
  document.addEventListener('shopify:section:load', initExpertOpinion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setReviewsDuplicateHidden(group) {
    group.setAttribute('aria-hidden', 'true');
    group.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
      node.setAttribute('tabindex', '-1');
    });
    group.querySelectorAll('[id], [data-shopify-editor-block], [data-shopify-editor-setting]').forEach(function (node) {
      node.removeAttribute('id');
      Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
        if (attribute.name.indexOf('data-shopify') === 0) {
          node.removeAttribute(attribute.name);
        }
      });
    });
  }

  function initReviewsMarquee() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-sd-reviews-slider]').forEach(function (root) {
      if (root.dataset.sdReviewsMarqueeInit) return;

      var viewport = root.querySelector('.sd-featured-products__reviews-marquee');
      var track = root.querySelector('[data-sd-reviews-track]');
      var initialGroups = track ? track.querySelectorAll('.sd-featured-products__reviews-group') : [];
      if (!viewport || !track || initialGroups.length < 2) return;

      root.dataset.sdReviewsMarqueeInit = '1';

      var beforeGroup = initialGroups[0].cloneNode(true);
      setReviewsDuplicateHidden(beforeGroup);
      track.insertBefore(beforeGroup, initialGroups[0]);

      var groups = track.querySelectorAll('.sd-featured-products__reviews-group');
      var loopWidth = 0;
      var frame = 0;
      var lastTime = 0;
      var pausedUntil = 0;
      var isPointerDown = false;
      var isHoverPaused = false;

      function measure() {
        groups = track.querySelectorAll('.sd-featured-products__reviews-group');
        if (groups.length < 3) return;
        loopWidth = groups[1].offsetLeft - groups[0].offsetLeft;
        if (!loopWidth) loopWidth = groups[2].offsetLeft - groups[1].offsetLeft;
        if (!loopWidth) loopWidth = track.scrollWidth / groups.length;
        if (loopWidth > 0 && viewport.scrollLeft < 1) {
          viewport.scrollLeft = loopWidth;
        }
        normalize();
      }

      function normalize() {
        if (!loopWidth) return;
        var lowerEdge = loopWidth * 0.5;
        var upperEdge = loopWidth * 1.5;

        if (viewport.scrollLeft < lowerEdge) {
          viewport.scrollLeft += loopWidth;
        } else if (viewport.scrollLeft >= upperEdge) {
          viewport.scrollLeft -= loopWidth;
        }
      }

      function cardStep() {
        var card = track.querySelector('.sd-featured-products__review');
        var group = track.querySelector('.sd-featured-products__reviews-group');
        if (!card || !group) return 0;
        var gap = parseFloat(window.getComputedStyle(group).columnGap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function pause(duration) {
        pausedUntil = performance.now() + duration;
      }

      function tick(time) {
        if (!root.isConnected) {
          window.cancelAnimationFrame(frame);
          return;
        }

        if (!lastTime) lastTime = time;
        var elapsed = time - lastTime;
        lastTime = time;

        if (!reduceMotion.matches && !isPointerDown && !isHoverPaused && time > pausedUntil) {
          var step = cardStep();
          if (step > 0) {
            viewport.scrollLeft += (step / 7.5) * (elapsed / 1000);
            normalize();
          }
        }

        frame = window.requestAnimationFrame(tick);
      }

      viewport.addEventListener('pointerdown', function () {
        isPointerDown = true;
        pause(1600);
      }, { passive: true });

      viewport.addEventListener('pointerup', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('pointercancel', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('touchstart', function () {
        isPointerDown = true;
        pause(1600);
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('wheel', function () {
        pause(1400);
      }, { passive: true });

      viewport.addEventListener('mouseenter', function () {
        isHoverPaused = true;
      });

      viewport.addEventListener('mouseleave', function () {
        isHoverPaused = false;
        lastTime = 0;
      });

      viewport.addEventListener('scroll', normalize, { passive: true });
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure).catch(function () {});
      }

      measure();
      frame = window.requestAnimationFrame(tick);

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target === root && frame) {
          window.cancelAnimationFrame(frame);
        }
      });
    });
  }
  initReviewsMarquee();
  document.addEventListener('shopify:section:load', initReviewsMarquee);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-knowledge-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-sd-knowledge-hub]');

  roots.forEach((root) => {
    if (root.dataset.sdKnowledgeInit === 'true') return;
    root.dataset.sdKnowledgeInit = 'true';

    const viewport = root.querySelector('.sd-knowledge-hub__slider-wrap');
    const track = root.querySelector('[data-sd-knowledge-track]');
    const prevButton = root.querySelector('[data-sd-knowledge-prev]');
    const nextButton = root.querySelector('[data-sd-knowledge-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!viewport || !track) return;

    const loopWidth = () => {
      const group = track.querySelector('.sd-knowledge-hub__article-group');
      if (!group) return track.scrollWidth / 2;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return group.scrollWidth + gap;
    };

    const cardStep = () => {
      const card = track.querySelector('.sd-knowledge-hub__article');
      if (!card) return 0;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const normalize = () => {
      const width = loopWidth();
      if (width > 0 && viewport.scrollLeft >= width) {
        viewport.scrollLeft -= width;
      }
    };

    let pausedUntil = 0;
    const pause = () => {
      pausedUntil = performance.now() + 1400;
    };

    viewport.addEventListener('pointerdown', pause, { passive: true });
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('wheel', pause, { passive: true });
    viewport.addEventListener('scroll', normalize, { passive: true });

    const move = (direction) => {
      const step = cardStep();
      if (step <= 0) return;
      pause();
      const width = loopWidth();
      if (direction < 0 && width > 0 && viewport.scrollLeft <= step * 0.6) {
        viewport.scrollLeft += width;
      }
      viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
      window.setTimeout(normalize, 480);
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => move(-1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => move(1));
    }

    if (reduceMotion) return;

    let frame = 0;
    let lastTime = 0;
    const tick = (time) => {
      if (!lastTime) lastTime = time;
      const elapsed = time - lastTime;
      lastTime = time;

      if (time > pausedUntil) {
        const step = cardStep();
        if (step > 0) {
          viewport.scrollLeft += (step / 7.5) * (elapsed / 1000);
          normalize();
        }
      }

      frame = window.requestAnimationFrame(tick);
    };

    frame = window.requestAnimationFrame(tick);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === root && frame) {
        window.cancelAnimationFrame(frame);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-social-media-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-sd-social-showcase]');

  sections.forEach((root) => {
    const viewport = root.querySelector('[data-sd-social-viewport]');
    const track = root.querySelector('[data-sd-social-track]');
    const prev = root.querySelector('[data-sd-social-prev]');
    const next = root.querySelector('[data-sd-social-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!viewport || !track) return;

    const loopWidth = () => {
      const group = track.querySelector('[data-sd-social-group]');
      if (!group) return track.scrollWidth / 2;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return group.scrollWidth + gap;
    };

    const normalizeScroll = () => {
      const width = loopWidth();
      if (width > 0 && viewport.scrollLeft >= width) {
        viewport.scrollLeft -= width;
      }
    };

    const cardStep = () => {
      const card = track.querySelector('.sd-social-showcase__card');
      if (!card) return 0;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    let resumeTimer;
    const pauseBriefly = () => {
      root.dataset.userPaused = 'true';
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        delete root.dataset.userPaused;
      }, 1100);
    };

    const scrollByCard = (direction) => {
      const step = cardStep();
      const width = loopWidth();
      if (!step || !width) return;
      pauseBriefly();
      if (direction < 0 && viewport.scrollLeft <= step) {
        viewport.scrollLeft += width;
      }
      viewport.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(normalizeScroll, 420);
    };

    if (prev) {
      prev.addEventListener('click', () => scrollByCard(-1));
    }

    if (next) {
      next.addEventListener('click', () => scrollByCard(1));
    }

    viewport.addEventListener('pointerdown', pauseBriefly, { passive: true });
    viewport.addEventListener('touchstart', pauseBriefly, { passive: true });
    viewport.addEventListener('wheel', pauseBriefly, { passive: true });
    viewport.addEventListener('scroll', normalizeScroll, { passive: true });

    const videos = Array.from(root.querySelectorAll('[data-sd-social-video]'));
    const shouldPlayVideos = root.dataset.playVideos === 'true' && !reduceMotion;

    if (videos.length && shouldPlayVideos && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { root: null, threshold: 0.45 });

      videos.forEach((video) => observer.observe(video));
    }

    const shouldAutoScroll = root.dataset.autoscroll === 'true' && !reduceMotion;

    if (!shouldAutoScroll) return;

    let animationFrame;
    let lastTime = 0;

    const tick = (time) => {
      if (!lastTime) {
        lastTime = time;
      }

      const elapsed = time - lastTime;
      lastTime = time;

      if (root.dataset.userPaused !== 'true') {
        const seconds = Math.max(parseFloat(root.dataset.autoscrollSeconds || '5'), 1);
        const step = cardStep();
        if (step > 0) {
          viewport.scrollLeft += (step / seconds) * (elapsed / 1000);
          normalizeScroll();
        }
      }

      animationFrame = window.requestAnimationFrame(tick);
    };

    animationFrame = window.requestAnimationFrame(tick);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === root && animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
